<template>
    <div class="setting" :class="{ disabled: disabled }">
        <!-- <div class="setting__label">{{$t(item.texts.Title)}}</div>
                                                    <div class="setting__option setting__plusmin">
                                                        <input type="number" min="-5" max="10" :value="item.value" step="5" readonly="readonly">
                                                    </div>
                                                    <div class="setting__option setting__unit">{{$t(converterType)}}</div>
                                                 -->

        <div class="setting__label" @click.prevent.stop="sub()">{{$t(item.texts.Title)}}</div>
        <div class="setting__option setting__plusmin" id="set-flow-air">
            <span class="setting__plusmin">
                <span class="sub" @click.prevent.stop="sub()">-</span>
                <input :disabled="disabled" id="ref-set-flow" type="number" min="0" max="100" :value="item.value | Rounder" step=".1" @keyup.enter.prevent="$event.target.blur()" @focus.prevent="onFocus(index,$event)" @blur.prevent="onBlur(index,$event)">
                <span class="add" @click.prevent.stop="add()">+</span>
            </span>
        </div>
        <div class="setting__option setting__unit" @click.prevent.stop="add()">{{$t(converterType)}}</div>
    </div>
</template>

<script>
import _ from 'lodash'
import { EventBus } from './../../event-bus.js';
import converter from './../../convert.service'

export default {
    name: 'input-field',
    props: ['item', 'index', 'unit', 'selectedindex'],
    data() {
        return {
            title: null,
            prevIndex: null,
            disabled: false, 
            interval : .1
        }
    },
    computed: {
        converterType() {

           

            if (this.item.inputParam === null) {
                if (this.item.texts.Title === 't-reference-relative-humidity') {
                    this.item.value = 0;
                    this.disabled = (this.selectedindex === 0 || this.selectedindex === 1) ? true : false;
                }
                return this.unit;
            }

            let param = this.$store.state.settings[this.item.inputParam];
            //  console.log({
            //     inputParam: this.item.inputParam,
            //     prevIndex: this.prevIndex,
            //     selected: param.selected,
            //     value: this.item.value
            // });

            //console.log(this.item.inputParam + ' from:' + this.prevIndex + ' to:' + param.selected);
            //convert item.value

            if (this.prevIndex !== undefined) {
                switch (this.item.inputParam) {
                    case 'CompressedAirFlow':
                        this.item.value = converter.Flow(this.prevIndex, param.selected, this.item.value);
                        break;
                    case 'Temperature':
                        this.item.value = converter.Temperature(this.prevIndex, param.selected, this.item.value);
                        break;
                    case 'Pressure':
                        this.item.value = converter.Pressure(this.prevIndex, param.selected, this.item.value);
                        break;
                    case 'CoolingWaterflow':
                        this.item.value = converter.CoolingWaterFlow(this.prevIndex, param.selected, this.item.value);
                        break;
                }
            }

            this.prevIndex = param.selected;
            const converterAddon = (this.item.inputParam === 'Pressure') ? "(a)" : '';
            return param.items[param.selected].name + converterAddon;
        }
    },
    methods: {
        selectItem() {
            //this.tech.selected = !this.tech.selected;
            this.$emit('unit-clicked', this);
        },
        sub() {
            this.item.value = (this.item.inputParam === null) ? converter.PercentValues(this.item.value, false, this.item.maxValue) : this.item.value -  this.interval;
            EventBus.$emit('updateCalculation');
        },
        add() {
            this.item.value = (this.item.inputParam === null) ? converter.PercentValues(this.item.value, true, this.item.maxValue) : this.item.value + this.interval;
            this.item.value = _.round(this.item.value, 1);
            EventBus.$emit('updateCalculation');
        },
        onFocus(index, e) {
            console.log('onFocus:' + this.item.inputParam);
            if (navigator.userAgent.match(/Edge\/(13|14)/)) {
                return setTimeout(e.target.select.bind(e.target), 10)
            } else {
                e.target.select();
            }
        },
        onBlur(index, e) {
            console.log(this.item.inputParam + ' onBlur:' + e.target.value);
            this.item.value = parseFloat(e.target.value);
            if (this.item.inputParam === null)
                this.item.value = converter.PercentValues(this.item.value, true, this.item.maxValue);
            //EventBus.$emit('updateCalculation');
        }
    },
    mounted: function() {
        // this.$nextTick(function() {
        //     //this.iTitle = (this.displayUnit) ? this.tech.type : this.tech.title;
        // });
    }
}
</script>

<style lang="css" scoped >
.disabled .setting__label,
.disabled .sub,
.disabled .add,
.disabled .setting__unit,
input[type=number]:disabled {
    pointer-events: none;
    -webkit-user-select: none;
    /* Chrome all / Safari all */
    -moz-user-select: none;
    /* Firefox all */
    -ms-user-select: none;
    /* IE 10+ */
    user-select: none;
    opacity: .5;
}

.disabled .sub,
.disabled .add {
    background-color: #DDD;
}

input[type=number]:disabled {
    background-color: #F5F5F6;
}
</style>


// WEBPACK FOOTER //
// input.field.vue?a71efbc0